import FullTextButton from "./FullTextButton";
import ManagePdfButton from "./ManagePdfButton";
import OpenAccessPdfButton from "./OpenAccessPdfButton";
import { PaperAccessButtonProps, PaperAccessButtonType } from "./types";
import UploadPdfButton from "./UploadPdfButton";

type Props = PaperAccessButtonProps & {
  type: PaperAccessButtonType;
};

const PaperAccessButton: React.FC<Props> = ({ type, ...props }) => {
  switch (type) {
    case PaperAccessButtonType.FULL_TEXT:
      return <FullTextButton {...props} />;
    case PaperAccessButtonType.UPLOAD_PDF:
      return <UploadPdfButton {...props} />;
    case PaperAccessButtonType.OPEN_ACCESS_PDF:
      return <OpenAccessPdfButton {...props} />;
    case PaperAccessButtonType.MANAGE_PDF:
      return <ManagePdfButton {...props} />;
    default:
      return null;
  }
};

export default PaperAccessButton;
export * from "./types";
